import { FC } from 'react'
import ShoppingCartProducts from '../shopping-cart/cart-page/ShoppingCartProducts'

const CheckoutItemsSummary: FC = () => {
  return (
    <div className="grow">
      <ShoppingCartProducts />
    </div>
  )
}

export default CheckoutItemsSummary
